import alwaysSrc from '!svg-inline!images/svg/targeting-display-heart.svg'
import displayWhenSrc from '!svg-inline!images/svg/targeting-display-target.svg'
import snoozeWindowSrc from '!svg-inline!images/svg/snooze-window.svg'
import sunWindowSrc from '!svg-inline!images/svg/sun-window.svg'

import TargetingOption from '../TargetingOption'

import styles from './style.styl'

const TargetingDisplay = ({
  onDisplayClick,
  onAlwaysClick,
  alwaysSelected,
  displayTargetingSelected,
  isOnFreePlan,
  onDisplayOnlineClick,
  onDisplayOfflineClick,
  displayOnlineSelected,
  displayOfflineSelected,
}) => (
  <div className={styles.TargetingDisplay}>
    <header className="playbook-title-header">
      <h2>Where would you like to display this Playbook?</h2>
      <p>Display to visitors who match the following conditions:</p>
    </header>

    <div className="playbook-targeting-choice-list">
      <TargetingOption
        iconSrc={alwaysSrc}
        isSelected={alwaysSelected}
        handleClick={onAlwaysClick}
        label="Display Always"
        description="Display this playbook on any page, at any time."
      />
      {isOnFreePlan &&
        <TargetingOption
          iconSrc={sunWindowSrc}
          isSelected={displayOnlineSelected}
          handleClick={onDisplayOnlineClick}
          label="Display When Drift is Online"
          description="Only display this playbook when Drift is online."
        />
      }
      {isOnFreePlan &&
        <TargetingOption
          iconSrc={snoozeWindowSrc}
          isSelected={displayOfflineSelected}
          handleClick={onDisplayOfflineClick}
          label="Display When Drift is Offline"
          description="Only display this playbook when Drift is offline."
        />
      }
      {!isOnFreePlan &&
        <TargetingOption
          iconSrc={displayWhenSrc}
          isSelected={displayTargetingSelected}
          handleClick={onDisplayClick}
          label="Display With Targeting"
          description="Add targeting conditions to display this message to a specific audience."
        />
      }
    </div>
  </div>
)

export default TargetingDisplay



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/component.js